/**
 * @generated SignedSource<<e6ab085c6fa7f29f94103a49b7e77282>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressForm_viewer$data = {
  readonly geography: {
    readonly countries: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
    readonly usStates: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly zipCodeLookUp?: ReadonlyArray<{
    readonly city: string | null;
    readonly state: string | null;
  } | null> | null;
  readonly " $fragmentType": "AddressForm_viewer";
};
export type AddressForm_viewer$key = {
  readonly " $data"?: AddressForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddressForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "canCheckZipCode"
    },
    {
      "kind": "RootArgument",
      "name": "country"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddressForm_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Geography",
      "kind": "LinkedField",
      "name": "geography",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "countries",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "usStates",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "canCheckZipCode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "zipCodeLookUp",
          "args": [
            {
              "kind": "Variable",
              "name": "country",
              "variableName": "country"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "zipCode"
            }
          ],
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "zipCode",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "35498c5bb635831d544d416a41852dfc";

export default node;
